var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[(_vm.indeterminate || _vm.max === 0)?_c('div',{staticClass:"progress-indeterminate"}):_c('div',{staticClass:"progress-value",style:({width: _vm.width})})])
}
var staticRenderFns = []

export { render, staticRenderFns }